export const environment = {
  production: true,
  urlWs: "/lrmGrandPublic/api"
};



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/environments/environment.ts